import { getFetch, postFetchWithBody, postFetchWithToken } from "../../utils/fetch";

async function getDestination(page) {
  const data = await getFetch(`/Location/destination/get?page=${page}`);
  if (data.status !== "error") {
    return {
      status: "success",
      message: data,
    };
  } else {
    return {
      status: data.status,
      message: "خطا در اتصال به سرور!",
    };
  }
}
async function storeDestination(form) {
  if (form.get('title') === '') {
    return {
      status: 'error',
      message: 'مقصد الزامی است!',
    }
  }

  const res = await postFetchWithToken("/Location/destination/store", form);
  if(res.status !== 'error'){
    return {
      status:'success',
      message:'مقصد با موفقیت ایجاد شد'
    }
  }else{
    return {
      status:res.status,
      message:res.message
    }
  }

}
async function deleteDestination(id) {
  const res = await postFetchWithBody(`/Location/destination/delete`, { id: id });
  if (res.status !== "error") {
    return {
      status: "success",
      message: res,
    };
  } else {
    return {
      status: res.status,
      message: "خطا در اتصال به سرور!",
    };
  }
}
export { getDestination, storeDestination,deleteDestination };
